export const csv = {
  configuration: {
    help: {
      type: "Analyze csv file by data structure or by configuration"
    },
    type: "Analysis",
    offset: "Offset",
    limit: "Limit",
    typeOptions: {
      manually: "Manually",
      dataStructure: "Data structure"
    },
    dataStructure: "Data structure",
    delimiter: "Delimiter",
    encoding: "Encoding",
    archiveCsvFile: "Archive csv file"
  },
  input: {
    help: {
      csvPath: 'Please provide a relative path (e.g. "in/test.csv").'
    },
    csvPath: "CSV file"
  },
  error: {
    error_handling: "Error handling",
    error_handlingOptions: {
      process_continues: "Workflow continues",
      process_aborts: "Workflow aborts"
    }
  }
};
